# Place all the behaviors and hooks related to the matching controller here.
# All this logic will automatically be available in application.js.
# You can use CoffeeScript in this file: http://jashkenas.github.com/coffee-script/

$(document).on 'turbolinks:load', ->
  $("#wallet_item_transfer_date").datepicker({ language: 'cs-CZ', dateFormat: "yy-mm-dd" })
